module.exports = __webpack_public_path__ + "img/dui.8bcc3bc9.png";